var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.55566 1.5H13.5001V2.5H5.55566V1.5Z",
    fill: "#414752"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 2C0.5 0.895501 1.36233 0 2.42592 0C3.48904 0.00125 4.35065 0.896001 4.35185 2C4.35185 3.1045 3.48952 4.00001 2.42592 4.00001C1.36233 4.00001 0.5 3.1045 0.5 2ZM1.46295 1.99999C1.46295 2.55224 1.89412 2.99999 2.42591 2.99999C2.95747 2.99924 3.38815 2.55199 3.38888 1.99999C3.38888 1.44774 2.95771 0.999992 2.42591 0.999992C1.89412 0.999992 1.46295 1.44774 1.46295 1.99999Z",
    fill: "#414752"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.55566 6.5H13.5001V7.5H5.55566V6.5Z",
    fill: "#414752"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 7C0.5 5.8955 1.36233 5 2.42592 5C3.48904 5.00125 4.35065 5.896 4.35185 7C4.35185 8.1045 3.48952 9.00001 2.42592 9.00001C1.36233 9.00001 0.5 8.1045 0.5 7ZM1.46295 7.00001C1.46295 7.55226 1.89412 8.00001 2.42591 8.00001C2.95747 7.99926 3.38815 7.55201 3.38888 7.00001C3.38888 6.44776 2.95771 6.00001 2.42591 6.00001C1.89412 6.00001 1.46295 6.44776 1.46295 7.00001Z",
    fill: "#414752"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.55566 11.5H13.5001V12.5H5.55566V11.5Z",
    fill: "#414752"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 12C0.5 10.8955 1.36233 10 2.42592 10C3.48904 10.0013 4.35065 10.896 4.35185 12C4.35185 13.1045 3.48952 14 2.42592 14C1.36233 14 0.5 13.1045 0.5 12ZM1.46295 12C1.46295 12.5523 1.89412 13 2.42591 13C2.95747 12.9993 3.38815 12.552 3.38888 12C3.38888 11.4478 2.95771 11 2.42591 11C1.89412 11 1.46295 11.4478 1.46295 12Z",
    fill: "#414752"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.5914653982a112694ef932605ff4a99b.svg";
export { ForwardRef as ReactComponent };